module.exports = __webpack_public_path__ + "static/media/Engpic4@3x.69d94bf5.png";